import { Box, IconButton, SimpleSelect, Stack, Typography } from '@chronosphereio/chrono-ui';
import { Close as CloseIcon } from 'mdi-material-ui';
import { LineStyleOverrideType } from '@/core';
import { OverrideOptionComponent } from '../types';

const LineStyleOptions = [
  { key: 'Dashed', label: 'Dashed' },
  { key: 'Solid', label: 'Solid' },
];

export const OverrideLineStyle: OverrideOptionComponent<LineStyleOverrideType | undefined> = ({
  onChange,
  value,
  onRemove,
  title,
}) => {
  const valueOrDefault = value ?? 'Solid';

  return (
    <Stack direction="row" alignItems="center" gap={2}>
      <Box flexGrow={0}>
        <Typography variant="subtitle1">{title}</Typography>
      </Box>

      <Box flexGrow={1}>
        <Box width={'100%'}>
          <SimpleSelect
            sx={{ width: '100%' }}
            fullWidth
            options={LineStyleOptions}
            value={valueOrDefault}
            onChange={(e) => onChange(e.target.value as LineStyleOverrideType)}
          />
        </Box>
      </Box>

      <Box flexGrow={0}>
        <IconButton size="small" onClick={onRemove}>
          <CloseIcon />
        </IconButton>
      </Box>
    </Stack>
  );
};
